import { AddTransactionRequestBody } from "@syla/shared/types/requests/TransactionRequests";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function addOrder(
  props: AddTransactionRequestBody,
): Promise<void> {
  const { accountId, ...rest } = props;
  try {
    await axios.post(`/accounts/${accountId}/orders`, rest);
  } catch (error) {
    throwSylaApiError(error);
  }
}
